<template>
  <div class="page-share-form text-sm">
    <b-form @submit.prevent="sharePage">
      <b-form-group>
        <b-form-input
          id="share-form-email"
          class="text-sm"
          v-model="form.email"
          type="text"
          :placeholder="$t('forms.emailAddress')"
          :disabled="formSending"
        ></b-form-input>
      </b-form-group>
      <b-button class="submit-btn btn btn-secondary text-uppercase"
                type="submit"
                variant="primary"
                :disabled="formSending">
                <b-spinner v-if="formSending" variant="white" type="grow" small></b-spinner>
                <span v-else>{{$t('forms.send')}}</span>
      </b-button>
    </b-form>
    <p class="error m-0">{{formError}}</p>
    <p class="success m-0" v-if="sendSuccess">{{$t('forms.sent')}}</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        email: '',
        url: window.location.href,
      },
      formSending: false,
      formError: '',
      sendSuccess: false,
    };
  },
  methods: {
    validEmail(email) {
      // eslint-disable-next-line
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validForm() {
      if (!this.form.email) {
        this.formError = this.$t('forms.emailIsRequired');
      } else if (!this.validEmail(this.form.email)) {
        this.formError = this.$t('forms.emailNotValid');
      } else {
        this.formError = '';
      }
      if (!this.formError) {
        return true;
      }
      return false;
    },
    sharePage() {
      this.sendSuccess = false;
      if (this.validForm()) {
        this.formSending = true;
        this.$http.post(`${process.env.VUE_APP_API_SUPPORT_URL}/page_share`, { email: this.form.email, url: this.form.url })
          .then(() => {
            this.formSending = false;
            this.sendSuccess = true;
            this.form.email = '';
          })
          .catch(() => {
            this.formSending = false;
            this.formError = this.$t('common.connectionError');
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.page-share-form {
  padding-left: 10px;
  padding-right: 10px;
}
form {
  position: relative;
  max-width: 400px;
  .form-group {
    margin: 0;
  }
  button {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0 .25rem .25rem 0!important;
    display: flex!important;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 67px;
    background-color: $secondary;
    color: #fff;
  }
}
.error {
  color: red;
}
.success {
  color: green;
}
</style>
